import { render, staticRenderFns } from "./login-privacy.vue?vue&type=template&id=842391d4&scoped=true"
import script from "./login-privacy.vue?vue&type=script&lang=ts"
export * from "./login-privacy.vue?vue&type=script&lang=ts"
import style0 from "./login-privacy.vue?vue&type=style&index=0&id=842391d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842391d4",
  null
  
)

export default component.exports